// Google OAuth
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useEffect } from 'react';

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import PostHogPageView from './components/PostHogPageView';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';

// ----------------------------------------------------------------------

const IS_PRODUCTION = process.env.REACT_APP_IS_PRODUCTION === 'true';

function loadScript(src, attrs = {}) {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  Object.entries(attrs).forEach(([key, value]) => script.setAttribute(key, value));
  document.body.appendChild(script);
}

function useDeferredAnalytics() {
  useEffect(() => {
    if (!IS_PRODUCTION) return;

    // Load GTM and analytics immediately (lightweight)
    loadScript('https://www.googletagmanager.com/gtag/js?id=G-2XEZ4G7HFP');
    window.dataLayer = window.dataLayer || [];
    function gtag(...args) { window.dataLayer.push(...args); }
    gtag('js', new Date());
    gtag('config', 'G-2XEZ4G7HFP');

    loadScript('/metricool.js');

    // Defer Tawk.to chat widget — load after 5 seconds
    const tawkTimer = setTimeout(() => {
      loadScript('/tawkto.js');
    }, 5000);

    return () => clearTimeout(tawkTimer);
  }, []);
}

export default function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  useDeferredAnalytics();

  return (
    <GoogleOAuthProvider clientId={googleClientId || 'default'}>
      <MotionLazyContainer>
        <ThemeProvider>
          <ThemeSettings>
            <NotistackProvider>
              <ProgressBarStyle />
              <ChartStyle />
              <ScrollToTop />
              <PostHogPageView />
              <Router />
            </NotistackProvider>
          </ThemeSettings>
        </ThemeProvider>
      </MotionLazyContainer>
    </GoogleOAuthProvider>
  );
}
